import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import Footer from '../../../footer/footer'
import { Age, Bar, Bedroom, Coffee, Cross, Cuisine, GreenTick, Heart, HotelSample, Kotak, Location, P1, P2, P3, P4, P5, S1, S2, Search, Sleeps, Smallarw, SquareFt, StarWhite, User, Watch, WishlistWhite } from '../../../assests/ExportImageIcon'
import '../hotelListing/hotelResults.css'
import './hotelDetail.css'
import service from '../../../services/service'
import endpoints from '../../../services/endpoints'
import { setHotelDetail, setSelectedHotel, setSelectedRoom } from '../../../redux/hotelSearch/hotelSearchSlice'
import SaveToWishlistButton from '../../../componants/wishlist/SaveToWishlistButton'
import useIndividualWishlistItems, { wishlistItemKey } from '../../../componants/wishlist/useIndividualWishlistItems'
import HotelSearchLoader from '../../../componants/hotelSearchLoader/HotelSearchLoader'
import Modal from '../../../componants/modal/Modal'
import ReviewsRatingSection from '../../../componants/reviewsRating/ReviewsRatingSection'
import { resolveOccupancy } from '../../../utils/hotelOccupancy'
const AMENITY_ICONS = [Cuisine, Coffee, Bar, Watch, GreenTick]

const GoldStar = ({ filled = true }) => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M7 10.65 2.89 12.95 3.8 8.33.34 5.13l4.68-.55L7 .29l1.98 4.29 4.68.55-3.46 3.2.92 4.62Z" fill={filled ? '#F5A623' : '#E5E7EB'} />
    </svg>
)

const ShieldIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M10 1.66667L16.6667 4.16667V9.16667C16.6667 13.0917 13.8517 16.7417 10 18.3333C6.14833 16.7417 3.33333 13.0917 3.33333 9.16667V4.16667L10 1.66667Z" stroke="#026D4D" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
)

const formatDateLabel = (value) => {
    if (!value) return ''
    const date = new Date(`${value}T00:00:00`)
    if (Number.isNaN(date.getTime())) return value
    return date.toLocaleDateString('en-GB', { weekday: 'short', day: '2-digit', month: 'short' })
}

const formatPrice = (price, currency = 'INR') => {
    const amount = Number(price)
    if (Number.isNaN(amount)) return price || '—'
    const symbol = currency === 'INR' ? '₹' : `${currency} `
    return `${symbol}${amount.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`
}

const normalizeImageUrl = (image) => {
    if (!image) return null
    if (typeof image === 'string') return image.trim() || null
    if (typeof image === 'object') {
        return image.url || image.thumbnail || image.path || image.src || null
    }
    return null
}

const extractFacilityValue = (facilities, label) => {
    const match = (facilities || []).find((item) =>
        String(item).toLowerCase().startsWith(String(label).toLowerCase())
    )
    if (!match) return null
    const parts = String(match).split(':')
    return parts.length > 1 ? parts.slice(1).join(':').trim() : match
}

const AMENITY_CATEGORY_DEFS = [
    { title: 'Internet access', keywords: ['wifi', 'wi-fi', 'internet'] },
    { title: 'Kitchen', keywords: ['kitchen', 'microwave', 'stove', 'dishwasher', 'cookware'] },
    { title: 'Food and drinks', keywords: ['breakfast', 'buffet', 'room service', 'meal', 'coffee shop', 'water bottle', 'restaurant', 'bar', 'snack', 'tea/coffee', 'minibar'] },
    { title: 'Activities and sports', keywords: ['swimming pool', 'hot tub', 'nightclub', 'fitness', 'gym', 'game room', 'badminton', 'bicycle rental', 'billiards', 'fishing', 'hiking', 'horseback', 'entertainment', 'recreational', 'ski', 'tennis', 'ticket service', 'tour', 'yoga', 'spa/sauna', 'spa'] },
    { title: 'Accessibility', keywords: ['wheelchair', 'accessible'] },
    { title: 'Outdoor', keywords: ['garden', 'backyard', 'outdoor', 'bbq', 'sun deck', 'sun terrace'] },
    { title: 'Family and kids', keywords: ['babysit', 'kids club', "kids' club", 'kids meal', 'children', 'kid-friendly', "kids' pool"] },
    { title: 'Transfers and transport', keywords: ['car parking', 'airport transfer', 'bicycle parking', 'car rental', 'shuttle', 'valet'] },
    { title: 'Bathroom', keywords: ['shower', 'toiletries', 'bathtub', 'bathrobe'] },
    { title: 'Room amenities', keywords: ['housekeeping', 'sauna', 'refrigerator', 'bedside socket', 'cleaning supplies', 'cupboard', 'dryer for clothes', 'first aid kit', 'hair dryer', 'hand sanitiser', 'heating', 'ironing', 'linens', 'safe box', 'seating area', 'slippers', 'sofa', 'soundproofing', 'telephone', 'television', 'wake-up call', 'wooden floor', 'safety deposit box', 'air condition', 'wardrobe', 'balcony'] },
    { title: 'Safety and security', keywords: ['security', 'cctv', 'smoke alarm', 'fire extinguisher'] },
    { title: 'Safety and cleanliness', keywords: ['anti-viral', 'disinfection', 'sanitisation', 'sanitization', 'protective screen', 'mask', 'hygiene', 'hand sanitiser', 'distancing', 'temperature check', 'sanitised', 'sanitized'] },
    { title: 'Services and conveniences', keywords: ['differently-abled', 'photocopy', 'fax', 'luggage storage', 'terrace', 'laundry', 'fireplace', 'currency exchange', 'dry-cleaning', 'dry cleaning', 'food delivery', 'gift', 'souvenir', 'postal service', 'shops', 'smoking area', 'steam room', 'concierge', 'free car parking', 'check-in/check-out', 'front desk', 'express check', 'non-smoking'] },
    { title: 'Languages spoken', keywords: ['english', 'hindi', 'language'] },
    { title: 'Other facilities', keywords: ['board game'] },
]

const categorizeAmenities = (facilities) => {
    const groups = new Map()
    ;(facilities || []).forEach((item) => {
        const label = String(item)
        const lower = label.toLowerCase()
        const match = AMENITY_CATEGORY_DEFS.find(({ keywords }) =>
            keywords.some((keyword) => lower.includes(keyword))
        )
        const title = match ? match.title : 'General Amenities'
        if (!groups.has(title)) groups.set(title, [])
        groups.get(title).push(label)
    })
    const ordered = ['General Amenities', ...AMENITY_CATEGORY_DEFS.map((def) => def.title)]
        .filter((title) => groups.has(title))
        .map((title) => ({ title, items: groups.get(title) }))

    const columns = [[], [], []]
    const columnCounts = [0, 0, 0]
    ordered.forEach((group) => {
        const shortestIndex = columnCounts.indexOf(Math.min(...columnCounts))
        columns[shortestIndex].push(group)
        columnCounts[shortestIndex] += group.items.length + 1
    })
    return columns
}

const extractRoomList = (payload) => {
    if (!payload) return []
    if (Array.isArray(payload)) return payload
    if (Array.isArray(payload.rooms)) return payload.rooms
    if (Array.isArray(payload.room_types)) return payload.room_types
    if (Array.isArray(payload.RoomTypes)) return payload.RoomTypes
    if (Array.isArray(payload.roomTypes)) return payload.roomTypes
    if (Array.isArray(payload.data)) return payload.data
    if (Array.isArray(payload?.data?.rooms)) return payload.data.rooms
    if (Array.isArray(payload?.data?.room_types)) return payload.data.room_types
    // single room object from /hotels/hotel/room/rate/
    if (payload.rate_key || payload.price != null || payload.room_type || payload.board_type) {
        return [payload]
    }
    if (payload.data && (payload.data.rate_key || payload.data.price != null || payload.data.room_type)) {
        return [payload.data]
    }
    return []
}

/** Turn API HTML breaks / tags into plain text (keep line breaks). */
const stripPolicyHtml = (value) => {
    if (value == null) return ''
    return String(value)
        .replace(/&lt;br\s*\/?&gt;/gi, '\n')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/gi, '&')
        .replace(/<\/?[^>]+>/g, '')
        .replace(/\r\n/g, '\n')
        .replace(/\n{3,}/g, '\n\n')
        .trim()
}

/** API sends multi-room values as "A|t|B|t|C" — use first meaningful value */
const cleanPipeValue = (value) => {
    if (value == null) return ''
    if (typeof value === 'object') return ''
    const text = stripPolicyHtml(value)
    if (!text) return ''
    if (!text.includes('|t|')) return text
    const parts = text.split('|t|').map((part) => part.trim()).filter(Boolean)
    return parts[0] || ''
}

/** Keep all cancellation lines; strip HTML and pipe separators. */
const cleanCancellationText = (value) => {
    if (value == null) return ''
    if (typeof value === 'object') return ''
    const text = stripPolicyHtml(value)
    if (!text) return ''
    if (!text.includes('|t|')) return text
    return text.split('|t|').map((part) => part.trim()).filter(Boolean).join('\n')
}

/** Normalize cancellation rules from db source: { rules: [{ title, refund_percentage }] } */
const normalizeCancellationRules = (policy) => {
    if (!policy) return []
    let rules = []
    if (Array.isArray(policy)) {
        rules = policy
    } else if (typeof policy === 'object') {
        if (Array.isArray(policy.rules)) rules = policy.rules
        else if (Array.isArray(policy.cancellation_rules)) rules = policy.cancellation_rules
        else if (Array.isArray(policy.policy_rules)) rules = policy.policy_rules
    }
    return rules
        .map((rule) => {
            if (rule == null) return null
            if (typeof rule === 'string') {
                const title = cleanPipeValue(rule) || rule
                return title ? { title, refund_percentage: null } : null
            }
            if (typeof rule !== 'object') return null
            const title = cleanPipeValue(rule.title || rule.name || rule.description || rule.text) || rule.title || rule.name || ''
            const pctRaw = rule.refund_percentage ?? rule.refundPercentage ?? rule.refund_percent ?? rule.percentage
            const refund_percentage = pctRaw == null || pctRaw === '' ? null : Number(pctRaw)
            if (!title && refund_percentage == null) return null
            return {
                title: title || (refund_percentage != null ? `${refund_percentage}% refund` : 'Cancellation rule'),
                refund_percentage: Number.isNaN(refund_percentage) ? null : refund_percentage,
            }
        })
        .filter(Boolean)
        // Non-refundable rules (red; exactly 0%) always precede refundable ones
        // (green; anything other than exactly 0%), regardless of API order
        .sort((a, b) => {
            const aRed = a.refund_percentage === 0 ? 1 : 0
            const bRed = b.refund_percentage === 0 ? 1 : 0
            if (aRed !== bRed) return bRed - aRed
            return (b.refund_percentage ?? 0) - (a.refund_percentage ?? 0)
        })
}

/**
 * Supports:
 * - string policies (third-party / pipe-delimited)
 * - object policies from source=db: { rules: [{ title, refund_percentage }] }
 */
const parseCancellationStatus = (value) => {
    if (value && typeof value === 'object') {
        const rules = normalizeCancellationRules(value)
        if (rules.length) {
            const hasRefund = rules.some((rule) => Number(rule.refund_percentage) > 0)
            const allFull = rules.every((rule) => Number(rule.refund_percentage) === 100)
            const allNone = rules.every((rule) => Number(rule.refund_percentage) === 0 || rule.refund_percentage == null)
            let refundStatus = 'Cancellation policy'
            if (allNone) refundStatus = 'Non-refundable'
            else if (allFull) refundStatus = 'Fully refundable'
            else if (hasRefund) refundStatus = 'Partially refundable'
            return {
                refundStatus,
                isRefundable: hasRefund,
                rules,
                description: typeof value.description === 'string' ? cleanCancellationText(value.description) : '',
            }
        }
        // object without rules — try text fields
        const text = value.description || value.title || value.text || value.policy || value.refund_status
        if (text) {
            const nested = parseCancellationStatus(text)
            return {
                ...nested,
                description: typeof value.description === 'string'
                    ? cleanCancellationText(value.description)
                    : nested.description || '',
            }
        }
    }

    if (Array.isArray(value)) {
        return parseCancellationStatus({ rules: value })
    }

    const cleaned = cleanCancellationText(value)
    if (!cleaned) {
        return { refundStatus: '', isRefundable: false, rules: [], description: '' }
    }
    const lower = cleaned.toLowerCase()
    if (lower.includes('non') && lower.includes('refund')) {
        return { refundStatus: cleaned, isRefundable: false, rules: [], description: '' }
    }
    if (lower.includes('refund') || lower.includes('free cancellation') || lower.includes('cancellable')) {
        return { refundStatus: cleaned, isRefundable: true, rules: [], description: '' }
    }
    return { refundStatus: cleaned, isRefundable: false, rules: [], description: '' }
}

const formatCancellationRuleLabel = (rule) => {
    if (!rule) return ''
    if (rule.refund_percentage != null && !Number.isNaN(Number(rule.refund_percentage))) {
        return `${rule.title} (${rule.refund_percentage}% refund)`
    }
    return rule.title || ''
}

const getRateList = (room) => {
    if (Array.isArray(room?.rates)) return room.rates
    if (Array.isArray(room?.options)) return room.options
    if (Array.isArray(room?.rate_plans)) return room.rate_plans
    if (Array.isArray(room?.ratePlans)) return room.ratePlans
    if (room?.price != null || room?.net_price != null || room?.total_price != null || room?.rate_key) {
        return [room]
    }
    return []
}

const mapRoomOption = (rate, currencyFallback = 'INR') => {
    const currency = rate.currency || rate.currency_code || currencyFallback
    const price = rate.price ?? rate.net_price ?? rate.total_price ?? rate.final_price ?? rate.amount
    const oldPrice = rate.old_price ?? rate.strike_price ?? rate.rack_rate ?? rate.original_price
    const taxes = rate.taxes ?? rate.tax ?? rate.taxes_and_fees ?? rate.tax_amount
    const boardName = cleanPipeValue(
        rate.board_type || rate.board_basis || rate.meal_plan || rate.board || rate.rate_name || rate.name
    )
    const cancellation = parseCancellationStatus(
        rate.cancellation_policy
        || rate.cancellationPolicy
        || rate.refund_status
        || rate.cancellation_status
        || rate.cancel_policy
    )
    const fareType = cleanPipeValue(rate.fare_type || rate.fareType)
    const fareLower = fareType.toLowerCase()
    const fareRefundable = fareLower
        ? (fareLower.includes('non') ? false : /refund/i.test(fareLower))
        : null
    const refundable = rate.refundable ?? rate.is_refundable ?? rate.isRefundable
    const hasRuleList = (cancellation.rules || []).length > 0
    const refundStatus = fareType
        || (hasRuleList
            ? cancellation.refundStatus
            : (
                cancellation.refundStatus
                || (refundable === true ? 'Refundable' : refundable === false ? 'Non-refundable' : 'Cancellation policy not available')
            ))
    const isRefundable = fareRefundable != null
        ? fareRefundable
        : (refundable != null ? Boolean(refundable) : cancellation.isRefundable)
    const rawPolicyText = rate.cancellation_policy || rate.cancellationPolicy || ''
    const cancellationText = (() => {
        if (hasRuleList) return ''
        const source = (
            cancellation.refundStatus
            && cancellation.refundStatus !== fareType
            && !/^(non-?)?refundable$/i.test(String(cancellation.refundStatus).trim())
        )
            ? cancellation.refundStatus
            : rawPolicyText
        const cleaned = cleanCancellationText(source)
        if (!cleaned || cleaned === fareType || /^(non-?)?refundable$/i.test(cleaned)) return ''
        return cleaned
    })()
    const description = cleanPipeValue(rate.description)
    // Prefer explicit perks; do not re-add board name (already shown as option name)
    const perksFromApi = rate.perks || rate.inclusions || rate.amenities || rate.benefits
    const perks = Array.isArray(perksFromApi)
        ? perksFromApi
            .map((item) => (typeof item === 'string' ? cleanPipeValue(item) : item?.name || item?.title || ''))
            .filter((item) => {
                if (!item) return false
                // Skip pure numbers (e.g. occupancy 150) and board name duplicates
                if (/^\d+(\.\d+)?$/.test(item)) return false
                if (boardName && item.toLowerCase() === boardName.toLowerCase()) return false
                return true
            })
        : (description && description !== boardName && !/^\d+(\.\d+)?$/.test(description)
            ? [description]
            : [])
    const roomsLeftValue = rate.rooms_left ?? rate.remaining_rooms ?? rate.available_rooms ?? rate.roomsLeft
    return {
        name: boardName || 'Room Only',
        fareType,
        refundStatus,
        isRefundable,
        cancellationText,
        cancellationRules: cancellation.rules || [],
        perks: [...new Set(perks)],
        oldPrice: oldPrice != null && oldPrice !== '' ? formatPrice(oldPrice, currency) : '',
        price: formatPrice(price, currency),
        rawPrice: Number(price),
        currency,
        taxesNote: taxes != null && taxes !== ''
            ? `+ ${formatPrice(taxes, currency)} taxes & fees`
            : (rate.taxes_note || rate.tax_note || ''),
        roomsLeft: roomsLeftValue != null && roomsLeftValue !== '' ? `${roomsLeftValue} rooms left` : '',
        rateKey: rate.rate_key || rate.rateKey || '',
        isAvailable: rate.is_available !== false,
        raw: rate,
    }
}

const mapRoomType = (room, index = 0) => {
    const images = (Array.isArray(room.images) ? room.images : Array.isArray(room.photos) ? room.photos : [])
        .map(normalizeImageUrl)
        .filter(Boolean)
    const thumbnail = normalizeImageUrl(room.thumbnail || room.image)
    const gallery = images.length ? images : (thumbnail ? [thumbnail] : [HotelSample])
    const facilities = Array.isArray(room.facilities)
        ? room.facilities
        : Array.isArray(room.amenities)
            ? room.amenities
            : []
    const title = cleanPipeValue(room.name || room.room_name || room.room_type || room.title) || `Room ${index + 1}`
    const roomSize = cleanPipeValue(room.room_size || room.size || room.area)
    const bedType = cleanPipeValue(room.bed_type || room.beds || room.bed)
    const sleeps = cleanPipeValue(room.max_occupancy || room.occupancy || room.sleeps || room.max_guests)
    const view = cleanPipeValue(room.view || room.room_view)
    const description = cleanPipeValue(room.description)
    const specs = [
        roomSize ? { icon: SquareFt, text: String(roomSize).toLowerCase().includes('sq') ? roomSize : `${roomSize} sq. mt.` } : null,
        bedType ? { icon: Bedroom, text: bedType } : null,
        description && description !== title ? { icon: Bedroom, text: description } : null,
        view ? { icon: Location, text: view } : null,
        sleeps ? { icon: Sleeps, text: `Sleeps ${sleeps}` } : null,
    ].filter(Boolean)
    const mappedFacilities = facilities
        .map((item) => (typeof item === 'string' ? cleanPipeValue(item) : item?.name || item?.title))
        .filter(Boolean)
    if (description && !mappedFacilities.includes(description)) {
        mappedFacilities.unshift(description)
    }
    const options = getRateList(room).map((rate) => mapRoomOption(rate, room.currency || 'INR'))
    return {
        id: room.rate_key || room.room_id || room.room_code || `${room.id || 'room'}-${index}`,
        title,
        images: gallery,
        photoCount: gallery.length > 1 ? `${gallery.length}+` : `${gallery.length}`,
        specs,
        facilities: mappedFacilities,
        options: options.length ? options : [mapRoomOption(room)],
        isAvailable: room.is_available !== false,
        raw: room,
    }
}


const HotelDetail = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const selectedHotel = useSelector((state) => state.hotelSearch.selectedHotel)
    const searchParams = useSelector((state) => state.hotelSearch.searchParams)
    const results = useSelector((state) => state.hotelSearch.results)
    const hotelDetail = useSelector((state) => state.hotelSearch.hotelDetail)
    const { individualId, savedMap } = useIndividualWishlistItems()
    const [showFullAbout, setShowFullAbout] = useState(false)
    const [loading, setLoading] = useState(true)
    const [roomsLoading, setRoomsLoading] = useState(false)
    const [roomTypes, setRoomTypes] = useState([])
    const [hotelRoomsAvailable, setHotelRoomsAvailable] = useState(true)
    const [rateRoomCount, setRateRoomCount] = useState(0)
    const [galleryOpen, setGalleryOpen] = useState(false)
    const [showAllSimilar, setShowAllSimilar] = useState(false)

    useEffect(() => {
        setShowFullAbout(false)
        setRoomTypes([])
        setHotelRoomsAvailable(true)
        setRateRoomCount(0)
        setShowAllSimilar(false)
    }, [id])

    useEffect(() => {
        const hotel = selectedHotel && String(selectedHotel.id) === String(id) ? selectedHotel : null
        if (!hotel && !id) {
            setLoading(false)
            return
        }

        const payload = {
            city: searchParams.city || hotel?.address?.city || '',
            country: searchParams.country || hotel?.address?.country || '',
            checkin: searchParams.checkIn || '',
            checkout: searchParams.checkOut || '',
            occupancy: resolveOccupancy(searchParams),
            requiredCurrency: searchParams.requiredCurrency || 'INR',
            source: hotel?.source || 'third_party',
            hotel_id: String(hotel?.id || id),
            session_id: results?.session_id || '',
            product_id: hotel?.productId || hotel?.product_id || '',
            token_id: hotel?.tokenId || hotel?.token_id || '',
        }

        setLoading(true)
        setRoomsLoading(true)
        service
            .post(endpoints.hotel.content, payload, { timeout: 45000, silent: true })
            .then(({ data }) => {
                const detail = data?.data || null
                dispatch(setHotelDetail(detail))
                setLoading(false)

                const keys = detail?.AccessKeys || {}
                const safeAccessKeys = {
                    hotel_id: String(keys.hotel_id || hotel?.id || id),
                    product_id: keys.product_id || payload.product_id,
                    session_id: keys.session_id || payload.session_id,
                    token_id: keys.token_id || payload.token_id,
                }
                const roomPayload = {
                    ...payload,
                    hotel_id: safeAccessKeys.hotel_id,
                    product_id: safeAccessKeys.product_id,
                    session_id: safeAccessKeys.session_id,
                    token_id: safeAccessKeys.token_id,
                    AccessKeys: safeAccessKeys,
                }

                // Persist the fallback-resolved keys so the booking page reads the
                // same hotel_id/session_id that was actually used for the room-rate
                // call, instead of the (possibly incomplete) raw content-API keys.
                dispatch(setHotelDetail({ ...(detail || {}), AccessKeys: safeAccessKeys }))

                return service
                    .post(endpoints.hotel.hotelRoom, roomPayload, { timeout: 45000, silent: true })
                    .then((roomRes) => {
                        const roomBody = roomRes?.data?.data ?? roomRes?.data ?? {}
                        // Hotel-level flag. Missing means available; false disables every book button.
                        setHotelRoomsAvailable(roomBody?.is_available !== false)
                        const payloadMeta = roomBody?.payload || {}
                        const occupancyLen = Array.isArray(payloadMeta.occupancy) ? payloadMeta.occupancy.length : 0
                        const fromApi = Number(payloadMeta.room_count)
                        setRateRoomCount(
                            (!Number.isNaN(fromApi) && fromApi > 0)
                                ? fromApi
                                : (occupancyLen || 0)
                        )
                        const rooms = extractRoomList(roomBody)
                        setRoomTypes(rooms.map(mapRoomType))
                    })
                    .catch(() => {
                        setHotelRoomsAvailable(true)
                        setRateRoomCount(0)
                        setRoomTypes([])
                    })
                    .finally(() => setRoomsLoading(false))
            })
            .catch(() => {
                dispatch(setHotelDetail(null))
                setHotelRoomsAvailable(true)
                setRateRoomCount(0)
                setRoomTypes([])
                setLoading(false)
                setRoomsLoading(false)
            })
    }, [id, selectedHotel, searchParams, results?.session_id, dispatch])

    const hotelInfo = hotelDetail?.hotelInfo || null
    const accessKeys = hotelDetail?.AccessKeys || null
    // Still used for the hero rating badge near the hotel name below
    // (hotelInfoCard__ratingBlock) — that badge is unrelated to the "Reviews
    // & Ratings" section further down, which now uses the shared
    // ReviewsRatingSection component against the new /bookings/rating*
    // endpoints instead of this vendor-content-embedded review data.
    const reviewData = hotelInfo?.review && typeof hotelInfo.review === 'object' ? hotelInfo.review : {}

    const galleryImages = useMemo(() => {
        const images = (Array.isArray(hotelInfo?.images) ? hotelInfo.images : [])
            .map(normalizeImageUrl)
            .filter(Boolean)
        if (images.length) return images
        const selectedThumb = normalizeImageUrl(selectedHotel?.thumbnail)
        if (selectedThumb) return [selectedThumb]
        return [HotelSample, P1, P2, P3, P5]
    }, [hotelInfo, selectedHotel])

    const openGallery = () => {
        setGalleryOpen(true)
    }

    const hotelName = hotelInfo?.name || selectedHotel?.name || 'Hotel'
    const hotelRating = Number(hotelInfo?.rating ?? selectedHotel?.rating ?? 0)
    const starCount = Number.isNaN(hotelRating) ? 0 : Math.max(0, Math.min(5, Math.round(hotelRating)))
    const address = hotelInfo?.address || selectedHotel?.address || {}
    const geo = hotelInfo?.location || {}
    const rawLat = geo.latitude ?? address.latitude
    const rawLng = geo.longitude ?? address.longitude
    const latitude = Number(rawLat)
    const longitude = Number(rawLng)
    const hasCoords = rawLat != null && rawLng != null && rawLat !== '' && rawLng !== '' && !Number.isNaN(latitude) && !Number.isNaN(longitude)
    const phone = hotelInfo?.phone || address.phone || selectedHotel?.phone || ''
    const email = hotelInfo?.email || address.email || selectedHotel?.email || ''
    const addressLine = [
        address.address,
        address.city,
        address.postal_code,
        address.country,
    ].filter(Boolean).join(', ')
    const description = hotelInfo?.description || ''
    const shortDescription = description.length > 280 ? `${description.slice(0, 280)}...` : description
    const facilities = Array.isArray(hotelInfo?.facilities) ? hotelInfo.facilities.filter(Boolean) : []
    const attractions = Array.isArray(hotelInfo?.attractions) ? hotelInfo.attractions : []
    const rules = Array.isArray(hotelInfo?.rules) ? hotelInfo.rules.filter(Boolean) : []
    const similarProperties = Array.isArray(hotelInfo?.similar_properties) ? hotelInfo.similar_properties : []
    // source=db sends object { rules: [{ title, refund_percentage }] }; third-party may send string
    const cancellationParsed = useMemo(
        () => parseCancellationStatus(
            hotelInfo?.cancellation_policy
            || hotelInfo?.cancellationPolicy
            || hotelDetail?.cancellation_policy
            || null
        ),
        [hotelInfo, hotelDetail]
    )
    const cancellationRules = cancellationParsed.rules || []
    const hasCancellation = Boolean(
        cancellationParsed.description
        || cancellationParsed.refundStatus
        || cancellationRules.length
    )
    const amenityColumns = useMemo(() => categorizeAmenities(facilities), [facilities])
    const totalRooms = extractFacilityValue(facilities, 'Total number of rooms')
    const minCheckInAge = extractFacilityValue(facilities, 'Minimum check-in age')
    const AMENITIES_PREVIEW_COUNT = 8
    const wifiIndex = facilities.findIndex((item) => /wi-?fi/i.test(String(item)))
    const visibleAmenities = wifiIndex >= AMENITIES_PREVIEW_COUNT
        ? [...facilities.slice(0, AMENITIES_PREVIEW_COUNT - 1), facilities[wifiIndex]]
        : facilities.slice(0, AMENITIES_PREVIEW_COUNT)
    const cheapestOption = useMemo(() => {
        let best = null
        roomTypes.forEach((room) => {
            (room.options || []).forEach((option) => {
                if (Number.isNaN(option.rawPrice)) return
                if (!best || option.rawPrice < best.rawPrice) best = option
            })
        })
        return best
    }, [roomTypes])

    const featuredRoom = roomTypes[0] || null
    const featuredFare = cheapestOption?.fareType
        ? cheapestOption
        : (featuredRoom?.options?.find((option) => option.fareType) || featuredRoom?.options?.[0] || null)
    const roomFacilities = featuredRoom?.facilities?.length ? featuredRoom.facilities : facilities
    const displayPrice = cheapestOption?.price
        || (selectedHotel?.price ? formatPrice(selectedHotel.price, selectedHotel.currency) : '—')

    // Trimmed to just what the hero rating badge below needs — the full
    // breakdown/categories/reviews this used to also compute moved into
    // ReviewsRatingSection, sourced from the real /bookings/rating* APIs.
    const reviewSummary = useMemo(() => ({
        totalReviews: Number(reviewData?.total_reviews || 0),
    }), [reviewData])

    const reserveRoomCount = Math.max(
        1,
        Number(rateRoomCount)
            || Number(searchParams.rooms)
            || (Array.isArray(searchParams.occupancy) ? searchParams.occupancy.length : 0)
            || 1
    )
    const reserveRoomLabel = `Reserve ${reserveRoomCount} Room${reserveRoomCount > 1 ? 's' : ''}`
    const guestsLabel = `${reserveRoomCount} Room${reserveRoomCount > 1 ? 's' : ''} & ${searchParams.adults || 1} Adult${(searchParams.adults || 1) > 1 ? 's' : ''}`
    const mapQuery = hasCoords
        ? `${latitude},${longitude}`
        : encodeURIComponent(addressLine || hotelName)

    const handleSimilarHotelClick = (hotel) => {
        if (!hotel?.id) return
        dispatch(setSelectedHotel(hotel))
        navigate(`/hotel-detail/${hotel.id}`)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    const isRoomBookable = (room, option) => (
        hotelRoomsAvailable && room?.isAvailable !== false && option?.isAvailable !== false
    )

    const handleReserveRoom = (room, option) => {
        if (!isRoomBookable(room, option)) return
        dispatch(setSelectedRoom({
            room,
            option,
            hotelId: hotelInfo?.id || id,
            hotelName: hotelName,
            selectedAt: new Date().toISOString(),
        }))
        navigate('/hotel-booking-detail')
    }

    if (loading) {
        return (
            <>
                <section className='allSearchArea commonTopPadding'>
                    <div className='container'>
                        <HotelSearchLoader text='Loading hotel details' />
                    </div>
                </section>
                <Footer />
            </>
        )
    }

    if (!hotelInfo && !selectedHotel) {
        return (
            <>
                <section className='allSearchArea commonTopPadding'>
                    <div className='container'>
                        <p className='hotelResultsEmpty'>Hotel details not available. Please search again.</p>
                    </div>
                </section>
                <Footer />
            </>
        )
    }

    return (
        <>
            <section className='allSearchArea commonTopPadding'>
                <div className='container'>
                    <div className='row g-4'>
                        <div className='col-md-12'>
                            <div className='innerSearch bgWhite paddingCommon20 borderRadius20'>
                                <div className='innerSearchBar'>
                                    <div className='innerSearchField'>
                                        <label>Location</label>
                                        <input type="text" readOnly value={[searchParams.city, searchParams.country].filter(Boolean).join(', ') || address.city || hotelName} />
                                    </div>
                                    <div className='innerSearchField'>
                                        <label>Check In</label>
                                        <input type="text" readOnly value={formatDateLabel(searchParams.checkIn) || 'Select date'} />
                                    </div>
                                    <div className='innerSearchField'>
                                        <label>Check Out</label>
                                        <input type="text" readOnly value={formatDateLabel(searchParams.checkOut) || 'Select date'} />
                                    </div>
                                    <div className='innerSearchField'>
                                        <label>Rooms &amp; Guests</label>
                                        <input type="text" readOnly value={guestsLabel} />
                                    </div>
                                    {/* <button type="button" className='innerSearchBtn'>
                                        Search
                                        <span>&#8250;</span>
                                    </button> */}
                                </div>
                            </div>
                        </div>

                        <div className='col-md-12'>
                            <div className='hotelAllDetail'>
                                <div className='hotelDetailGrid'>
                                    <div className='hotelDetailLeft'>
                                        <div className='hotelGallery'>
                                            <div className='hotelGallery__main'>
                                                <img src={galleryImages[0]} alt={hotelName} />
                                            </div>
                                            <div className='hotelGallery__grid'>
                                                {(galleryImages.slice(1, 5).length ? galleryImages.slice(1, 5) : [galleryImages[0]]).map((img, index) => (
                                                    <div
                                                        className={index === 3 ? 'hotelGallery__lastItem' : undefined}
                                                        key={`${img}-${index}`}
                                                    >
                                                        <img src={img} alt={hotelName} />
                                                        {index === 3 ? <button type='button' className='hotelGallery__showAll' onClick={() => openGallery()}>Show all photos</button> : null}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        <div className='hotelInfoCard'>
                                            <div className='hotelInfoCard__top'>
                                                <div>
                                                    <div className='hotelInfoCard__name'>{hotelName}</div>
                                                    <div className='hotelCard__stars'>
                                                        {Array.from({ length: starCount || 0 }).map((_, index) => <GoldStar key={index} />)}
                                                    </div>
                                                </div>
                                                <div className='hotelInfoCard__ratingBlock'>
                                                    <span className='hotelCard__ratingBadge'>
                                                        <img src={StarWhite} alt="" /> {hotelRating || '0'}
                                                    </span>
                                                    <span className='hotelInfoCard__reviews'>
                                                        {reviewSummary.totalReviews
                                                            ? `${Number(reviewSummary.totalReviews).toLocaleString('en-IN')} reviews`
                                                            : 'No reviews yet'}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className='hotelInfoCard__divider' />

                                            <div className='hotelInfoCard__location'>
                                                <span className='hotelInfoCard__locationIcon'>
                                                    <img src={Location} alt="" />
                                                </span>
                                                <div className='hotelCard__location'>
                                                    <div>
                                                        <div className='hotelCard__locationName'>{[address.city, address.country].filter(Boolean).join(', ') || '—'}</div>
                                                        {/* <div className='hotelCard__locationNote'>{address.address || ''}</div>
                                                        {address.postal_code ? <div className='hotelCard__locationNote'>PIN: {address.postal_code}</div> : null}
                                                        {phone ? <div className='hotelCard__locationNote'>Phone: {phone}</div> : null}
                                                        {email ? <div className='hotelCard__locationNote'>Email: {email}</div> : null} */}
                                                    </div>
                                                </div>
                                                <a
                                                    href={hasCoords
                                                        ? `https://www.google.com/maps?q=${latitude},${longitude}`
                                                        : `https://www.google.com/maps?q=${mapQuery}`}
                                                    target='_blank'
                                                    rel='noreferrer'
                                                    className='hotelInfoCard__arrow'
                                                    aria-label="View location"
                                                >
                                                    <img src={Smallarw} alt="" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='hotelDetailRight'>
                                        <div className='hotelRoomCard'>
                                            <div className='hotelRoomCard__title'>{featuredRoom?.title || hotelName}</div>
                                            <div className='hotelRoomCard__fits'>{guestsLabel}</div>

                                            <ul className='hotelRoomCard__perks'>
                                                {totalRooms ? <li><img src={GreenTick} alt="" /> Total rooms: {totalRooms}</li> : null}
                                                {minCheckInAge ? <li><img src={Age} alt="" /> Minimum check-in age: {minCheckInAge}</li> : null}
                                                {roomFacilities.some((item) => /wi-?fi/i.test(item)) ? <li><img src={GreenTick} alt="" /> Free Wi-fi</li> : null}
                                                {roomFacilities.some((item) => /room service/i.test(item)) ? <li><img src={GreenTick} alt="" /> Room service</li> : null}
                                                {roomFacilities.some((item) => /24-hour reception/i.test(item)) ? <li><img src={Watch} alt="" /> 24-hour reception</li> : null}
                                                {!hasCancellation ? (
                                                    <li className='hotelRoomCard__perk--tick'>
                                                        <img src={Cross} alt="" /> Cancellation policy not available
                                                    </li>
                                                ) : null}
                                            </ul>

                                            {featuredFare?.fareType ? (
                                                <ul className='hotelRoomCard__perks'>
                                                    <li className={featuredFare.isRefundable ? undefined : 'hotelRoomCard__perk--tick'}>
                                                        <img src={featuredFare.isRefundable ? GreenTick : Cross} alt="" />
                                                        {' '}
                                                        {featuredFare.fareType}
                                                    </li>
                                                </ul>
                                            ) : cancellationRules.length ? (
                                                <ul className='hotelRoomCard__perks'>
                                                    {cancellationRules.slice(0, 2).map((rule, index) => {
                                                        const refundableRule = Number(rule.refund_percentage) !== 0
                                                        return (
                                                            <li key={index} className={refundableRule ? undefined : 'hotelRoomCard__perk--tick'}>
                                                                <img src={refundableRule ? GreenTick : Cross} alt="" />
                                                                {' '}
                                                                {formatCancellationRuleLabel(rule)}
                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                            ) : cancellationParsed.refundStatus ? (
                                                <ul className='hotelRoomCard__perks'>
                                                    <li className={cancellationParsed.isRefundable ? undefined : 'hotelRoomCard__perk--tick'}>
                                                        <img src={cancellationParsed.isRefundable ? GreenTick : Cross} alt="" />
                                                        {' '}
                                                        {cancellationParsed.refundStatus}
                                                    </li>
                                                </ul>
                                            ) : null}

                                            {/* <a href="#room-details" className='hotelRoomCard__viewAll'>View All</a> */}

                                            <div className='hotelRoomCard__priceBlock'>
                                                <div className='hotelRoomCard__oldPriceRow'>
                                                    {cheapestOption?.oldPrice ? <span className='hotelRoomCard__oldPrice'>{cheapestOption.oldPrice}</span> : null}
                                                    <span className='hotelRoomCard__perNight'>Per Night:</span>
                                                </div>
                                                <div className='hotelRoomCard__price'>
                                                    {roomsLoading ? 'Loading...' : displayPrice}
                                                    {cheapestOption?.taxesNote ? <span> {cheapestOption.taxesNote}</span> : null}
                                                </div>
                                            </div>

                                            <button
                                                type='button'
                                                className='commonBtn w-100'
                                                disabled={!hotelRoomsAvailable}
                                                title={hotelRoomsAvailable ? undefined : 'This hotel is not available for the selected dates'}
                                                onClick={() => document.getElementById('room-details')?.scrollIntoView({ behavior: 'smooth' })}
                                            >
                                                Select Room
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-12'>
                            <div className='bsSectionTitle'>About This Property</div>
                            <div className='aboutProperty bgWhite commonBorder borderRadius20 paddingCommon20'>
                                <p className='aboutProperty__desc'>
                                    {showFullAbout ? description : shortDescription || 'No description available.'}
                                </p>
                                {description.length > 280 ? (
                                    <button
                                        type='button'
                                        className='aboutProperty__readMore'
                                        onClick={() => setShowFullAbout((prev) => !prev)}
                                    >
                                        {showFullAbout ? 'READ LESS' : 'READ MORE'}
                                    </button>
                                ) : null}
                            </div>
                        </div>

                        <div className='col-md-12'>
                            <div className='amenities__head'>
                                <div className='bsSectionTitle'>Amenities</div>
                                {facilities.length > AMENITIES_PREVIEW_COUNT ? (
                                    <button
                                        type='button'
                                        className='tripSecureViewAll'
                                        onClick={() => document.getElementById('all-facilities')?.scrollIntoView({ behavior: 'smooth' })}
                                    >
                                        View All
                                    </button>
                                ) : null}
                            </div>
                            <div className='amenities'>
                                <div className='amenities__row bgWhite commonBorder borderRadius20 paddingCommon20'>
                                    {(visibleAmenities.length ? visibleAmenities : ['No amenities listed']).map((label, index) => (
                                        <div className='amenities__item' key={`${label}-${index}`}>
                                            <img src={AMENITY_ICONS[index % AMENITY_ICONS.length]} alt="" />
                                            <span>{label}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className='col-md-12'>
                            <div className='bsSectionTitle'>Location</div>
                            <div className='hotelLocation bgWhite commonBorder borderRadius20 paddingCommon20'>
                                <div className='hotelLocation__grid'>
                                    <div className='hotelLocation__left'>
                                        <div className='hotelLocation__address'>
                                            <strong>Address:</strong> {addressLine || '—'}
                                        </div>
                                        {phone ? <div className='hotelCard__locationNote'>Phone: {phone}</div> : null}
                                        {email ? <div className='hotelCard__locationNote'>Email: {email}</div> : null}
                                        {hasCoords ? (
                                            <div className='hotelCard__locationNote'>
                                                Coordinates: {latitude}, {longitude}
                                            </div>
                                        ) : null}

                                        {attractions.length ? (
                                            <>
                                                <div className='hotelLocation__searchBox'>
                                                    <img src={Search} alt="" />
                                                    <input type='text' placeholder='Search property distance from...' readOnly />
                                                </div>
                                                <ul className='hotelLocation__list'>
                                                    {attractions.map((item, index) => (
                                                        <li key={index}>
                                                            <span>{item.place || item.name || item}</span>
                                                            <span className='hotelLocation__listRight'>
                                                                {item.distance != null ? `${item.distance} km` : ''}
                                                                <img src={Smallarw} alt="" />
                                                            </span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </>
                                        ) : (
                                            <p className='hotelCard__locationNote mt-3'>No nearby attractions listed.</p>
                                        )}
                                    </div>

                                    <div className='hotelLocation__map'>
                                        <iframe
                                            title='Hotel Location'
                                            src={`https://www.google.com/maps?q=${mapQuery}&z=14&output=embed`}
                                            loading='lazy'
                                            allowFullScreen
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                                                          {/* room list */}
                        <div className='col-md-12' id='room-details'>
                            <div className='roomType'>
                                <div className='bsSectionTitle'>Select Room</div>
                                <div className='roomTypeList'>
                                    {roomsLoading ? (
                                        <HotelSearchLoader size='compact' text='Loading rooms' />
                                    ) : null}
                                    {!roomsLoading && !roomTypes.length ? (
                                        <p className='hotelResultsEmpty'>No rooms available for selected dates.</p>
                                    ) : null}
                                    {roomTypes.map((room, roomIndex) => (
                                        <div className='roomTypeCard bgWhite commonBorder borderRadius20' key={room.id || roomIndex}>
                                            <div className='roomTypeCard__grid'>
                                                <div className='roomTypeCard__left' style={{ gridRow: `1 / span ${Math.max(room.options.length, 1)}` }}>
                                                    <div className='roomTypeCard__gallery'>
                                                        <Swiper modules={[Pagination]} pagination={{ clickable: true }} loop={room.images.length > 1}>
                                                            {room.images.map((img, imgIndex) => (
                                                                <SwiperSlide key={imgIndex}>
                                                                    <img src={img} alt={room.title} />
                                                                </SwiperSlide>
                                                            ))}
                                                        </Swiper>
                                                        <span className='roomTypeCard__photoCount'>{room.photoCount}</span>
                                                    </div>
                                                    <div
                                                        className='roomTypeCard__title'
                                                        onClick={() => isRoomBookable(room, room.options?.[0]) && handleReserveRoom(room, room.options[0])}
                                                        role="button"
                                                        tabIndex={0}
                                                    >
                                                        {room.title}
                                                    </div>
                                                    {room.specs.length ? (
                                                        <div className='roomTypeCard__specs'>
                                                            {room.specs.map((spec, specIndex) => (
                                                                <span key={specIndex}><img src={spec.icon} alt="" /> {spec.text}</span>
                                                            ))}
                                                        </div>
                                                    ) : null}
                                                    <div className='roomTypeCard__divider' />
                                                    {/* <button
                                                        type='button'
                                                        className='hotelRoomCard__viewAll'
                                                        onClick={() => room.options?.[0] && handleReserveRoom(room, room.options[0])}
                                                    >
                                                        View Details
                                                    </button> */}
                                                </div>

                                                {room.options.map((option, optionIndex) => (
                                                    <React.Fragment key={optionIndex}>
                                                        <div className={`roomTypeOption${optionIndex === room.options.length - 1 ? ' roomTypeOption--last' : ''}`}>
                                                            <div className='roomTypeOption__name'>{option.name}</div>
                                                            <div className='roomTypeOption__perks'>
                                                                {option.fareType ? (
                                                                    <span className={`roomTypeOption__perk${option.isRefundable ? '' : ' roomTypeOption__perk--negative'}`}>
                                                                        <img src={option.isRefundable ? GreenTick : Cross} alt="" /> {option.fareType}
                                                                    </span>
                                                                ) : null}
                                                                {/* Rules list once — avoid refundStatus + policyPerks double render */}
                                                                {(option.cancellationRules || []).length ? (
                                                                    option.cancellationRules.map((rule, ruleIndex) => {
                                                                        const refundableRule = Number(rule.refund_percentage) !== 0
                                                                        return (
                                                                            <span
                                                                                className={`roomTypeOption__perk${refundableRule ? '' : ' roomTypeOption__perk--negative'}`}
                                                                                key={`cancel-${ruleIndex}`}
                                                                            >
                                                                                <img src={refundableRule ? GreenTick : Cross} alt="" />
                                                                                {' '}
                                                                                {formatCancellationRuleLabel(rule)}
                                                                            </span>
                                                                        )
                                                                    })
                                                                ) : option.fareType ? (
                                                                    option.cancellationText ? (
                                                                        <span className='roomTypeOption__perk roomTypeOption__perk--policy'>
                                                                            {option.cancellationText}
                                                                        </span>
                                                                    ) : null
                                                                ) : (
                                                                    <span className={`roomTypeOption__perk${option.isRefundable ? '' : ' roomTypeOption__perk--negative'}${String(option.refundStatus || '').includes('\n') ? ' roomTypeOption__perk--policy' : ''}`}>
                                                                        <img src={option.isRefundable ? GreenTick : Cross} alt="" /> {option.refundStatus}
                                                                    </span>
                                                                )}
                                                                {(option.perks || []).map((perk, perkIndex) => (
                                                                    <span className='roomTypeOption__perk' key={`perk-${perkIndex}`}>
                                                                        <img src={GreenTick} alt="" /> {stripPolicyHtml(perk)}
                                                                    </span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                        <div className={`roomTypePrice${optionIndex === room.options.length - 1 ? ' roomTypePrice--last' : ''}`}>
                                                            <div className='roomTypePrice__oldRow'>
                                                                {option.oldPrice ? <span className='roomTypePrice__old'>{option.oldPrice}</span> : null}
                                                                <span className='roomTypePrice__current'>{option.price}</span>
                                                            </div>
                                                            {option.taxesNote ? <div className='roomTypePrice__note'>{option.taxesNote}</div> : null}
                                                            {option.roomsLeft ? <div className='roomTypePrice__left'>{option.roomsLeft}</div> : null}
                                                            <button
                                                                type='button'
                                                                className='commonBtn roomTypePrice__btn'
                                                                disabled={!isRoomBookable(room, option)}
                                                                title={isRoomBookable(room, option) ? undefined : 'This room is not available'}
                                                                onClick={() => handleReserveRoom(room, option)}
                                                            >
                                                                {reserveRoomLabel}
                                                            </button>
                                                        </div>
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className='col-md-12'>
                            <ReviewsRatingSection service='hotel' objectId={hotelInfo?.id || id} />
                        </div>

                        <div className='col-md-12' id='all-facilities'>
                            <div className='bsSectionTitle'>All Amenities</div>
                            <div className='allAmeneties bgWhite commonBorder borderRadius20 paddingCommon20'>
                                <div className='allAmeneties__grid'>
                                    {facilities.length ? (
                                        amenityColumns.map((column, colIndex) => (
                                            <div className='allAmeneties__column' key={`amenity-col-${colIndex}`}>
                                                {column.map((group) => (
                                                    <div className='amenityGroup' key={group.title}>
                                                        <div className='amenityGroup__title'>{group.title}</div>
                                                        <ul className='bsInfoList'>
                                                            {group.items.map((item, index) => (
                                                                <li key={`${item}-${index}`}>{item}</li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                ))}
                                            </div>
                                        ))
                                    ) : (
                                        <div className='allAmeneties__column'>
                                            <div className='amenityGroup'>
                                                <div className='amenityGroup__title'>Amenities (0)</div>
                                                <ul className='bsInfoList'>
                                                    <li>No facilities listed</li>
                                                </ul>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className='col-md-12'>
                            <div className='propertySummary'>
                                <div className='bsSectionTitle'>Property Summary</div>
                                <div className='propertySummary__row'>
                                    <div className='propertySummaryCard bgWhite commonBorder borderRadius20'>
                                        <span className='propertySummaryCard__icon'><img src={Watch} alt="" /></span>
                                        <div className='propertySummaryCard__label'>Check-in</div>
                                        <div className='propertySummaryCard__value'>{formatDateLabel(searchParams.checkIn) || '—'}</div>
                                    </div>
                                    <div className='propertySummaryCard bgWhite commonBorder borderRadius20'>
                                        <span className='propertySummaryCard__icon'><img src={Watch} alt="" /></span>
                                        <div className='propertySummaryCard__label'>Check-out</div>
                                        <div className='propertySummaryCard__value'>{formatDateLabel(searchParams.checkOut) || '—'}</div>
                                    </div>
                                    {/* Hidden for now: only Check-in / Check-out are shown in Property Summary.
                                    <div className='propertySummaryCard bgWhite commonBorder borderRadius20'>
                                        <span className='propertySummaryCard__icon'><ShieldIcon /></span>
                                        <div className='propertySummaryCard__label'>Source</div>
                                        <div className='propertySummaryCard__value'>{hotelInfo?.source || '—'}</div>
                                    </div>
                                    <div className='propertySummaryCard bgWhite commonBorder borderRadius20'>
                                        <span className='propertySummaryCard__icon'><img src={Age} alt="" /></span>
                                        <div className='propertySummaryCard__label'>Hotel ID</div>
                                        <div className='propertySummaryCard__value'>{hotelInfo?.id || accessKeys?.hotel_id || id}</div>
                                    </div>
                                    {totalRooms ? (
                                        <div className='propertySummaryCard bgWhite commonBorder borderRadius20'>
                                            <span className='propertySummaryCard__icon'><img src={Bedroom} alt="" /></span>
                                            <div className='propertySummaryCard__label'>Total Rooms</div>
                                            <div className='propertySummaryCard__value'>{totalRooms}</div>
                                        </div>
                                    ) : null}
                                    {minCheckInAge ? (
                                        <div className='propertySummaryCard bgWhite commonBorder borderRadius20'>
                                            <span className='propertySummaryCard__icon'><img src={Age} alt="" /></span>
                                            <div className='propertySummaryCard__label'>Min. Check-in Age</div>
                                            <div className='propertySummaryCard__value'>{minCheckInAge}+</div>
                                        </div>
                                    ) : null}
                                    {accessKeys?.product_id ? (
                                        <div className='propertySummaryCard bgWhite commonBorder borderRadius20'>
                                            <span className='propertySummaryCard__icon'><ShieldIcon /></span>
                                            <div className='propertySummaryCard__label'>Product ID</div>
                                            <div className='propertySummaryCard__value'>{accessKeys.product_id}</div>
                                        </div>
                                    ) : null}
                                    {phone ? (
                                        <div className='propertySummaryCard bgWhite commonBorder borderRadius20'>
                                            <span className='propertySummaryCard__icon'><img src={User} alt="" /></span>
                                            <div className='propertySummaryCard__label'>Phone</div>
                                            <div className='propertySummaryCard__value'>{phone.split(',')[0].trim()}</div>
                                        </div>
                                    ) : null}
                                    */}
                                </div>
                            </div>
                        </div>

                        <div className='col-md-12'>
                            <div className='propertyRules'>
                                <div className='bsSectionTitle'>Property Rules & Information</div>
                                <div className='propertyRules__card bgWhite commonBorder borderRadius20 paddingCommon20'>
                                    {cancellationParsed.description || cancellationRules.length ? (
                                        <div className='propertyRules__highlight'>
                                            <div className='propertyRules__highlightTitle'>
                                                <img src={Heart} alt="" /> Cancellation Policy
                                            </div>
                                            {cancellationParsed.description ? (
                                                <div className='propertyRules__highlightDesc'>{cancellationParsed.description}</div>
                                            ) : null}
                                            {cancellationRules.length ? (
                                                <ul className='bsInfoList propertyRules__list mt-2'>
                                                    {cancellationRules.map((rule, index) => (
                                                        <li key={`cancel-highlight-${index}`}>
                                                            {formatCancellationRuleLabel(rule)}
                                                        </li>
                                                    ))}
                                                </ul>
                                            ) : null}
                                        </div>
                                    ) : cancellationParsed.refundStatus ? (
                                        <div className='propertyRules__highlight'>
                                            <div className='propertyRules__highlightTitle'>
                                                <img src={Heart} alt="" /> Cancellation Policy
                                            </div>
                                            <div className='propertyRules__highlightDesc'>{cancellationParsed.refundStatus}</div>
                                        </div>
                                    ) : null}

                                    <ul className='bsInfoList propertyRules__list'>
                                        {(rules.length
                                            ? rules
                                            : [
                                                minCheckInAge ? `Primary guest should be at least ${minCheckInAge} years of age.` : null,
                                                !hasCancellation ? 'Cancellation policy not provided by the property.' : null,
                                                'No specific house rules provided.',
                                            ].filter(Boolean)
                                        ).map((rule, index) => (
                                            <li key={index}>{rule}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-12'>
                            <div className='similarProperty'>
                                <div className='bsSectionTitle'>Similar Properties</div>
                                <div className='hotelList'>
                                    {(showAllSimilar ? similarProperties : similarProperties.slice(0, 2)).map((hotel) => {
                                        const thumb = normalizeImageUrl(hotel.thumbnail) || HotelSample
                                        const city = hotel.address?.city || ''
                                        const country = hotel.address?.country || ''
                                        const similarRating = Number(hotel.rating)
                                        const similarStars = Number.isNaN(similarRating)
                                            ? 0
                                            : Math.max(0, Math.min(5, Math.round(similarRating)))
                                        return (
                                            <div
                                                className='hotelListItem'
                                                key={hotel.id}
                                                role='button'
                                                tabIndex={0}
                                                onClick={() => handleSimilarHotelClick(hotel)}
                                                onKeyDown={(event) => {
                                                    if (event.key === 'Enter' || event.key === ' ') {
                                                        event.preventDefault()
                                                        handleSimilarHotelClick(hotel)
                                                    }
                                                }}
                                            >
                                                <div className='hotelCard'>
                                                    <div className='hotelCard__media'>
                                                        <Swiper modules={[Pagination]} pagination={{ clickable: true }} loop={false}>
                                                            <SwiperSlide>
                                                                <img src={thumb} alt={hotel.name} />
                                                            </SwiperSlide>
                                                        </Swiper>
                                                        <SaveToWishlistButton
                                                            item={{
                                                                recordModule: 'hotel',
                                                                recordId: hotel.id,
                                                                recordName: hotel.name,
                                                                imageUrl: thumb,
                                                                provider: hotel.service_provider || hotelInfo?.service_provider,
                                                            }}
                                                            preSavedItemId={savedMap.get(wishlistItemKey('hotel', hotel.id))}
                                                            preSavedWishlistId={individualId}
                                                        />
                                                    </div>

                                                    <div className='hotelCard__info'>
                                                        <div className='hotelCard__topRow'>
                                                            <div>
                                                                <div className='hotelCard__rating'>
                                                                    <span className='hotelCard__ratingBadge'>
                                                                        <img src={StarWhite} alt="" /> {hotel.rating || '0'}
                                                                    </span>
                                                                    <div className='hotelCard__stars'>
                                                                        {Array.from({ length: similarStars }).map((_, index) => (
                                                                            <GoldStar key={index} />
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                                <div className='hotelCard__name'>{hotel.name}</div>
                                                            </div>
                                                            <div className='hotelCard__price'>
                                                                <div className='hotelCard__priceValue'>{formatPrice(hotel.price, hotel.currency)}</div>
                                                                <div className='hotelCard__priceLabel'>Per Night</div>
                                                            </div>
                                                        </div>

                                                        <div className='hotelCard__bottomRow mt-4'>
                                                            <div className='hotelCard__location'>
                                                                <img src={Location} alt="" />
                                                                <div>
                                                                    <div className='hotelCard__locationName'>{[city, country].filter(Boolean).join(', ') || '—'}</div>
                                                                    <div className='hotelCard__locationNote'>{hotel.address?.address || ''}</div>
                                                                </div>
                                                            </div>
                                                            <div className='hotelCard__amenities'>
                                                                {(hotel.facilities || []).slice(0, 4).map((amenity, index) => (
                                                                    <span className='hotelCard__amenityPill' key={`${amenity}-${index}`}>{amenity}</span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* <div className='hotelOfferBanner'>
                                                    <img src={Kotak} alt="Kotak" className='hotelOfferBanner__icon' />
                                                    <div>
                                                        <div className='hotelOfferBanner__title'>EXCLUSIVE OFFERS</div>
                                                        <div className='hotelOfferBanner__text'>KOTAK Credit Card NoCostEMI Offer - Get INR 596/- Off!</div>
                                                    </div>
                                                </div> */}
                                            </div>
                                        )
                                    })}
                                </div>
                                {!similarProperties.length ? <p className='hotelResultsEmpty'>No similar properties found.</p> : null}
                                {!showAllSimilar && similarProperties.length > 2 ? (
                                    <button
                                        type='button'
                                        className='travellerAddBtn'
                                        onClick={() => setShowAllSimilar(true)}
                                    >
                                        View All Properties
                                    </button>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />

            <Modal open={galleryOpen} onClose={() => setGalleryOpen(false)} maxWidth={880} className="policyModal">
                <div className='venueGalleryModal'>
                    <div className='venueGalleryModal__title'>
                        {hotelName} — {galleryImages.length} Photo{galleryImages.length === 1 ? '' : 's'}
                    </div>
                    <div className='venueGalleryModal__grid'>
                        {galleryImages.map((src, index) => (
                            <img key={index} src={src} alt={`${hotelName} ${index + 1}`} />
                        ))}
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default HotelDetail
